<template>
  <div class="container">
    <dv-border-box-7 class="message">
      <div>正在识别身份, 请稍候...</div>
    </dv-border-box-7>
  </div>
</template>

<script>
import service from "@/utils/request";
import router from "@/router";
export default {
  name: "auth_identity",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    service
      .get("/synthesis/businessData")
      .then(function (response) {
        console.log('___________',response);
        if (response && response.data.code != 403) {
          router.push({ name: "IntegratedData" });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #fff;
  font-size: 60px;
}

.message {
  width: 80%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 180px;
}

.message div {
  animation: loading 0.3s ease-in-out infinite;
}

@keyframes loading {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
